module.exports = __webpack_public_path__ + "media/images/menu/ganymede-46b704af4adb03315ee1504d7a712fd8.jpg";